import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { Link, LinkProps } from '@mui/material';
import tokens from '@verifime/design-tokens';

export default function PrivacyPolicyLinkWithIcon({ children, ...props }: LinkProps) {
  const childNode = children || 'Privacy Policy';
  return (
    <Link
      href="https://www.verifime.com/privacy"
      target="_blank"
      {...props}
      sx={{ ...props.sx, display: 'inline-flex', alignItems: 'center', gap: tokens.spacingXs }}
    >
      {childNode}
      <OpenInNewRoundedIcon fontSize="small" />
    </Link>
  );
}
